module.exports = __webpack_public_path__ + "img/6.08d0c97d.png";